<template>
  <form-section
    :title="$t('InappSettings_Polling_Title')"
    :description="$t('InappSettings_Polling_Description')"
  >
    <el-row>
      <el-col :span="8">
        <rest-form-item
          prop="inapp_polling_interval"
          :label="$t('InappSettings_PollingInterval')"
          :description="$t('InappSettings_PollingInterval_Desc')"
        >
          <el-input-number
            v-model="model.inapp_polling_interval"
            :disabled="!$isAdmin()"
          />
        </rest-form-item>
      </el-col>
      <el-col :span="8">
        <rest-form-item
          prop="inapp_polling_duration"
          :label="$t('InappSettings_PollingDuration')"
          :description="$t('InappSettings_PollingDuration_Desc')"
        >
          <el-input-number
            v-model="model.inapp_polling_duration"
            :disabled="!$isAdmin()"
          />
        </rest-form-item>
      </el-col>
      <el-col :span="8">
        <rest-form-item
          prop="inapp_polling_auto"
          :label="$t('InappSettings_PollingAuto')"
          :description="$t('InappSettings_PollingAuto_Desc')"
        >
          <toggle v-model="model.inapp_polling_auto" />
        </rest-form-item>
      </el-col>
    </el-row>

    <rest-form-item
      prop="inapp_polling_events"
      :label="$t('InappSettings_PollingEvents')"
      :description="$t('InappSettings_PollingEvents_Desc')"
    >
      <el-select v-model="model.inapp_polling_events" multiple filterable>
        <el-option
          v-for="event in events"
          :key="event.title"
          :label="event.title"
          :value="event.title"
        />
      </el-select>
    </rest-form-item>
  </form-section>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import Toggle from '@/common/components/form/Toggle'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'InappPollingSettings',
  components: {
    Toggle,
    RestFormItem,
    FormSection
  },
  data() {
    return {
      events: []
    }
  },
  computed: {
    platform() {
      switch (this.model.type) {
        case 'ios':
          return 1
        case 'android':
          return 2
        case 'web':
          return 3
        default:
          return null
      }
    }
  },
  props: {
    model: {
      required: true
    }
  },
  mounted() {
    RestApi(
      projectEndpoint({
        method: 'get',
        url: 'events',
        params: {
          sort: 'title',
          source_platforms: this.platform
        }
      })
    ).then(({ data }) => {
      this.events = data.map(event => {
        return { title: event.title || event.type }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/InappPollingSettings.vue